import { Heading, P, Section } from 'components/base';
import PropTypes from 'prop-types';
import React from 'react';
import Carousel from 'react-slick';
import { bContent, root, tagC, tagsC } from './Example.module.scss';

const Example = ({ data, theme, padding, tags }) => {
  const Item = ({ heading, img, desc }) => {
    return (
      <div className={root}>
        <div>
          <img src={img.publicURL} alt={heading} />
        </div>
        <div className={bContent}>
          <Heading Tag="h3" bold size="SM" marginBottom="Xxs" center>
            {heading}
          </Heading>
          <P center>{desc}</P>
        </div>
      </div>
    );
  };
  Item.propTypes = {
    heading: PropTypes.string.isRequired,
    desc: PropTypes.string.isRequired,
    img: PropTypes.object.isRequired,
  };

  const Tag = ({ text }) => (
    <div className={tagC}>{text}</div>
  );
  Tag.propTypes = {
    text: PropTypes.string.isRequired,
  }

  const settings = {
    className: "exampleCarousel",
    centerMode: true,
    infinite: true,
    centerPadding: "26%",
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 850,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          focusOnSelect: false,
          centerPadding: "0px",
        }
      },
    ]
  };

  return (
    <Section padding={padding} theme={theme}>
      <Carousel {...settings}>
        {data.map((props, i) => (
          <Item {...props} key={i} />
        ))}
      </Carousel>
      <div className={tagsC}>
        {tags.map((props, i) => (
          <Tag text={props} key={i} />
        ))}
      </div>
    </Section>
  );
};

Example.propTypes = {
  data: PropTypes.array.isRequired,
  tags: PropTypes.array.isRequired,
  theme: PropTypes.string,
  padding: PropTypes.string,
};

Example.defaultProps = {
  padding: 'BottomL',
  theme: null,
};

export default Example;
